import useURLsBase from 'sfccAPI/hooks/useURLs';
import {useLocalesMgr} from 'coreHooks';
import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

export const useURLs = (opts = {}) => {
	const {managerRepository} = useGeneralProvider();
	const useBaseURLs = useURLsBase(opts);
	const localesMgr = useLocalesMgr();
	const currentLocale = localesMgr.getCurrentLocale();

	return {
		...useBaseURLs,
		CART_PROXY: managerRepository.getSfccAPI().generateEndpointUrl('Cart-Proxy', true),
		CART: managerRepository.getSfccAPI().generateEndpointUrl('COCart-Show', true),
		// TODO: Recheck this URL after country/language.
		CUSTOMER_SERVICE: `https://support.casadei.com/hc/${currentLocale.getLanguageCode()}`,
		CUSTOMER_SERVICE_RETURN: `https://support.casadei.com/hc/${currentLocale.getLanguageCode()}/categories/14753387823260-Returns`,
		GOOGLE_PRIVACY_POLICY: 'https://policies.google.com/privacy',
		GOOGLE_TERMS: 'https://policies.google.com/terms',
	};
};
